if (!customElements.get('quick-add-variant-picker')) {
  customElements.define(
    'quick-add-variant-picker',
    class QuickAddVariantPicker extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.quick-add-variant-picker__trigger');
        this.panel = this.querySelector('.quick-add-variant-picker__panel');
        this.variants = JSON.parse(
          this.querySelector('.quick-add-variant-picker__data').textContent
        );
        this.selects = Array.from(this.querySelectorAll('.quick-add-variant-picker__select'));
        this.input = this.querySelector('.quick-add-variant-picker__variant-id');
        this.button = this.querySelector('.quick-add-variant-picker__submit');
        this.addText = this.querySelector('.quick-add-variant-picker__add-text');
        this.soldOutText = this.querySelector('.sold-out-message');

        this.trigger.addEventListener('click', this.open.bind(this));
        this.panel.addEventListener('change', this.onChange.bind(this));
        document.addEventListener('click', this.onOutsideClick.bind(this));
      }

      open(event) {
        event.stopPropagation();
        this.dataset.state = 'open';
        this.trigger.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
      }

      close() {
        this.dataset.state = 'closed';
        this.trigger.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
      }

      onOutsideClick(event) {
        if (this.dataset.state === 'open' && !this.contains(event.target)) {
          this.close();
        }
      }

      onChange() {
        const values = this.selects.map((select) => select.value);
        const allSelected = values.every((v) => v !== '');

        if (!allSelected) {
          this.setState('incomplete');
          return;
        }

        const variant = this.variants.find((variant) =>
          variant.options.every((opt, i) => opt === values[i])
        );

        if (!variant) {
          this.setState('unavailable');
          return;
        }

        this.input.value = variant.id;
        this.input.disabled = false;
        this.setState(variant.available ? 'available' : 'sold-out');
      }

      setState(state) {
        this.button.disabled = state !== 'available';
        this.addText.classList.toggle('hidden', state === 'sold-out');
        this.soldOutText.classList.toggle('hidden', state !== 'sold-out');
        if (state !== 'available') this.input.disabled = true;
      }
    }
  );
}